import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";

import { useNavigate } from "react-router-dom";
import {
  qtyPrize750,
  qtyPrize115,
  qtyPrize190,
  qtyPrize1900,
  qtyPrize376,
} from "constants/sorteios";

import * as S from "./Home.style";
import InputNumber from "components/Form/InputNumber";
import useTitles from "hooks/useTitles";
import { useEffect, useState } from "react";
import { useAppContext } from "contexts/AppContext";
import ActionFooter from "components/ActionFooter/ActionFooter";
import SkeletonCard from "components/SkeletonCard";
import ErroGenerico from "components/ErroGenerico";
import Form from "components/Form";
import useProdutos from "hooks/useProdutos";
import { getEnvVar } from "utils/environment";

const Home = () => {
  const { titleAmount = 1, setProductData: setProduct } = useAppContext();
  const [titles, setTitles] = useState(titleAmount);
  const [productData, setProductData] = useState();
  const { data, error, getTitles } = useTitles();
  const { data: produtos, error: errorProdutos } = useProdutos();

  useEffect(() => {
    if (produtos?.conteudo) {
      setProductData({
        produto: produtos?.conteudo[0].identificacao.codigo,
        versao: produtos?.conteudo[0].dados.codigoVersaoNegocio,
      });
    }
  }, [produtos?.conteudo]);

  useEffect(() => {
    if (productData) {
      getTitles(productData);
    }
  }, [getTitles, productData]);

  const navigate = useNavigate();

  const handleSubmit = ({ titles: numTitles }) => {
    setProduct({ titleAmount: numTitles, ...productData });
    navigate("/unico/resumo");
  };

  if (error || errorProdutos) {
    return <ErroGenerico />;
  }

  if (!data) {
    return (
      <Section>
        <SkeletonCard />
      </Section>
    );
  }

  return (
    <section>
      <Section>
        <ResponsiveCard
          maxContent
          logoCap
          title="Não perca a oportunidade de ganhar mais prêmios!"
        >
          <S.HomeContentContainer>
            <h3 className="noBold">
              Por R$ 14,99 por título você aumenta suas chances de concorrer :)
            </h3>
            <S.ContentSectionContainer>
              <h3>
                <strong>Prêmios mensais</strong>
              </h3>
              <h3 className="noBold">
                Os sorteios são realizados no último sábado de cada mês.
              </h3>
              <S.PrizeContainer>
                <p>
                  {qtyPrize115} prêmios de &nbsp;
                  <strong>R$ 115</strong>
                </p>
                <p>
                  {qtyPrize190} prêmios de &nbsp;
                  <strong>R$ 190</strong>
                </p>
                <p>
                  {qtyPrize376} prêmios de &nbsp;
                  <strong>R$ 376</strong>
                </p>
                <p>
                  {qtyPrize750} prêmios de &nbsp;
                  <strong>R$ 750</strong>
                </p>
                <p>
                  {qtyPrize1900} prêmios de &nbsp;
                  <strong>R$ 1.900</strong>
                </p>
              </S.PrizeContainer>
            </S.ContentSectionContainer>
            <S.ContentSectionContainer>
              <h3>
                <strong>Prêmio único</strong>
              </h3>
              <h3 className="noBold">
                O sorteio é realizado no penúltimo sábado do 12º mês.
              </h3>
              <S.PrizeContainer>
                <p>
                  1 prêmio de &nbsp;
                  <strong>R$ 1.000.000</strong>
                </p>
              </S.PrizeContainer>
            </S.ContentSectionContainer>
            <h3>
              <strong>Quantos títulos você prefere comprar?</strong>
            </h3>
            <Form onSubmit={handleSubmit} scheme={{ titles: titleAmount }}>
              <InputNumber
                options={data?.quantidade}
                value={titles}
                onChange={setTitles}
                name="titles"
              />
              <ActionFooter
                primaryLabel="Continuar"
                goBackTo={getEnvVar("AA_CAP_VENCEDOR")}
                isUrl
              />
            </Form>
          </S.HomeContentContainer>
        </ResponsiveCard>
      </Section>
    </section>
  );
};

export default Home;
